import { jsx } from "react/jsx-runtime";
import react, { useEffect, useState } from "react";
import { Box, Text } from "pcln-design-system";
import { hotelSummaryManager } from "../generateHotelSummary.js";
import { useChatMessagesContext } from "../../hooks/useChatMessagesContext.js";
const HotelAISummary = ({ shouldDisplayGenHotelFeature, propertyName, isExpressDeal, fetchRequestOptions, description, starRating, hotelAmenities, petDescription })=>{
    const [summary, setSummary] = useState('');
    const { chatMessages } = useChatMessagesContext();
    useEffect(()=>{
        let intervalId;
        let mounted = true;
        if (!isExpressDeal && shouldDisplayGenHotelFeature && propertyName) {
            const hotelDetail = {
                hotelName: propertyName,
                description,
                starRating,
                hotelFeatures: hotelAmenities?.map((feature)=>feature.name),
                petPolicy: petDescription
            };
            hotelSummaryManager.addHotelSummary(propertyName, {
                prompts: chatMessages?.filter((msg)=>!!msg.content),
                source: 'newHotelListingCard',
                fetchRequestOptions,
                hotelDetail
            });
            const checkSummary = ()=>{
                const summaryResult = hotelSummaryManager.getHotelSummary(propertyName);
                if (mounted) {
                    summaryResult?.status !== 'ERROR' ? setSummary(summaryResult?.text || '') : setSummary('');
                    if (summaryResult?.status === 'DONE' || summaryResult?.status === 'ERROR') {
                        if (intervalId) clearInterval(intervalId);
                    }
                }
            };
            checkSummary();
            intervalId = setInterval(checkSummary, 200);
        }
        return ()=>{
            mounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        propertyName,
        isExpressDeal,
        shouldDisplayGenHotelFeature,
        description,
        starRating,
        hotelAmenities,
        petDescription,
        fetchRequestOptions
    ]);
    if (!summary) return null;
    return /*#__PURE__*/ jsx(Box, {
        "data-testid": "hotel-ai-summary",
        children: /*#__PURE__*/ jsx(Text, {
            fontSize: 0,
            lineHeight: "20px",
            pb: 1,
            pt: 2,
            children: summary
        })
    });
};
const HotelAISummaryMemo = /*#__PURE__*/ react.memo(HotelAISummary, (prev, next)=>prev.propertyName === next.propertyName);
HotelAISummaryMemo.displayName = 'HotelAISummary';
export { HotelAISummary, HotelAISummaryMemo };
